/**
 * WEB-3447, заход 3 — дверь страницы (квиз, пейволл) к единому ленивому
 * куску плеера. Кусок нужен воронке, если нужен любой из трёх наборов:
 *  - вычисляемые значения — имя из списка в тексте (`funnelUsesComputedValues`);
 *  - градиенты и переменные пака — градиент в теле, ленивая тема, пак с
 *    дополнительными полями (`funnelNeedsStyleKit`, `packNeedsStyleKit`);
 *  - рамка Slimkit — пак визарда её включает (`packNeedsQuizChromeKit`;
 *    только квиз — пейволл визард с рамкой не рисует, `chromePackId` не задаёт)
 *    либо поля шапки квиза (`chromeHeader` = `settings.quizHeader`, слово
 *    владельца 20.10.2026) просят шеврон или крестик (`quizHeaderNeedsChromeKit`),
 *    либо поля главной кнопки (`chromeCta` = `settings.quizCta`, слово владельца
 *    21.10.2026) просят прибитую панель или затемнение (`quizCtaNeedsChromeKit`),
 *    либо хоть один экран квиза (`chromeScreens`) прибивает кнопку своим полем
 *    `ctaPlacement` (`screensNeedCtaDock`, задание stylepack/cta-screen-placement).
 * Нужен, а куска нет — `waiting` (страница держит прелоадер до первого
 * кадра). Не нужен — кусок не заказывается.
 */
import { useMemo } from 'react';
import { playerKitDoor } from './playerKitDoor';
import { funnelUsesComputedValues } from './computedValuesDoor';
import { packNeedsQuizChromeKit } from '@/components/quiz-runtime/quizChromeKitDoor';
import { quizHeaderNeedsChromeKit } from '@/components/quiz-runtime/quizHeader';
import {
  quizCtaNeedsChromeKit,
  screensNeedCtaDock,
} from '@/components/quiz-runtime/quizCta';
import { funnelNeedsStyleKit, packNeedsStyleKit } from '@/themes/styleKitDoor';
import { getStylePackById, hasStylePackLoaded } from '@/themes/stylePacks';

const loadedPack = (id: string | null | undefined) =>
  id && hasStylePackLoaded(id) ? getStylePackById(id) : undefined;

export function usePlayerKitDoor(
  body: unknown,
  themeId: unknown,
  stylePackIds: ReadonlyArray<string | null | undefined>,
  chromePackId?: string,
  chromeHeader?: unknown,
  chromeCta?: unknown,
  chromeScreens?: unknown,
): { readonly waiting: boolean } {
  const bodyNeeds = useMemo(
    () =>
      funnelUsesComputedValues(body) || funnelNeedsStyleKit(body, themeId, []),
    [body, themeId],
  );
  return playerKitDoor.useDoor(
    bodyNeeds ||
      stylePackIds.some((id) => packNeedsStyleKit(loadedPack(id))) ||
      packNeedsQuizChromeKit(loadedPack(chromePackId)) ||
      quizHeaderNeedsChromeKit(chromeHeader) ||
      quizCtaNeedsChromeKit(chromeCta) ||
      screensNeedCtaDock(chromeScreens),
  );
}
